// src/pages/CategoriaFinanceira/CategoriaFinanceiraForm.jsx

import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../../components/Header';
import api from '../../services/api';
import { showSuccess, showError } from '../../services/alert';

const CategoriaFinanceiraForm = () => {
  const { id } = useParams();                         
  const isEditing = Boolean(id && id !== 'novo');
  const navigate = useNavigate();

  const [categoria, setCategoria] = useState({
    nome: '',
    tipo: '',      
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isEditing) {
      setLoading(true);
      api.get(`/categoriafinanceira/${id}`)
        .then(response => {
          const d = response.data;
          setCategoria({
            nome: d.nome,
            tipo: d.tipo,
          });
        })
        .catch(err => {
          console.error('Erro ao carregar categoria financeira:', err);
          showError('Erro ao carregar categoria.');
        })
        .finally(() => setLoading(false));
    }
  }, [id, isEditing]);

  const handleChange = e => {
    const { name, value } = e.target;
    setCategoria(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (!categoria.nome.trim()) {
      showError('O campo "Nome" é obrigatório.');
      return;
    }
    if (categoria.tipo !== 'Receita' && categoria.tipo !== 'Despesa') {
      showError('Selecione um tipo válido (Receita ou Despesa).');
      return;
    }

    // **Aqui incluímos o "id" no payload**
    const payload = {
      id: isEditing ? Number(id) : 0,      // <--- adiciona o ID
      nome: categoria.nome.trim(),
      tipo: categoria.tipo,
    };

    setLoading(true);
    try {
      if (isEditing) {
        await api.put(`/categoriafinanceira/${id}`, payload);
        showSuccess('Categoria atualizada com sucesso.');
      } else {
        await api.post('/categoriafinanceira', payload);
        showSuccess('Categoria criada com sucesso.');
      }
      navigate('/categoriafinanceira');
    } catch (err) {
      console.error('Erro ao salvar categoria financeira:', err);
      showError(err.response?.data?.message || 'Erro ao salvar categoria.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <Header />
      <div className="card shadow-lg border-0 rounded-3">
        <div className="card-header bg-success text-white d-flex align-items-center gap-3 rounded-top-3">
          <button
            className="btn btn-light btn-sm d-flex align-items-center gap-1"
            onClick={() => navigate('/categoriafinanceira')}
            disabled={loading}
          >
            <i className="bi bi-arrow-left text-success" />
            <span className="text-success fw-semibold">Voltar</span>
          </button>
          <h5 className="mb-0">
            {isEditing ? 'Editar Categoria Financeira' : 'Nova Categoria Financeira'}
          </h5>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit} className="row g-4">
            <fieldset className="border p-3 rounded-3">
              <legend className="px-3 text-success fw-semibold">Dados da Categoria</legend>

              <div className="col-md-6">
                <label className="form-label fw-semibold">Nome</label>
                <input
                  type="text"
                  name="nome"
                  value={categoria.nome}
                  onChange={handleChange}
                  className="form-control rounded-3"
                  maxLength={100}
                  required
                  disabled={loading}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">Tipo</label>
                <select
                  name="tipo"
                  value={categoria.tipo}
                  onChange={handleChange}
                  className="form-select rounded-3"
                  required
                  disabled={loading}
                >
                  <option value="">Selecione...</option>
                  <option value="Receita">Receita</option>
                  <option value="Despesa">Despesa</option>
                </select>
              </div>

              <div className="col-12 d-flex justify-content-end mt-3">
                <button
                  type="submit"
                  className="btn btn-success me-2 d-flex align-items-center gap-1"
                  disabled={loading}
                >
                  <i className="bi bi-save" />
                  <span>{loading ? 'Salvando...' : 'Salvar'}</span>
                </button>
                <button
                  type="button"
                  className="btn btn-secondary d-flex align-items-center gap-1"
                  onClick={() => navigate('/categoriafinanceira')}
                  disabled={loading}
                >
                  <i className="bi bi-x-circle" />
                  <span>Cancelar</span>
                </button>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CategoriaFinanceiraForm;
